<div class="p-4 space-y-3 flex flex-col h-full">

  <div class="flex items-center gap-3 flex-wrap">
    <h2 class="text-sm font-semibold text-gray-900 dark:text-white flex items-center gap-2">
      <i class="fa-solid fa-microscope text-app-teal-100"></i>Instrument Details
    </h2>

    <div class="inline-flex rounded border border-gray-300 dark:border-[#434863] overflow-hidden text-xs" role="group" aria-label="Backend stack">
      <button
        *ngFor="let s of stacks"
        class="px-3 py-1 border-r border-gray-300 dark:border-[#434863] last:border-r-0 transition"
        [class.bg-app-teal-100]="stack === s.key"
        [class.text-white]="stack === s.key"
        [class.text-gray-700]="stack !== s.key"
        [class.dark:text-gray-300]="stack !== s.key"
        [class.hover:bg-gray-50]="stack !== s.key"
        [class.dark:hover:bg-app-blue-100]="stack !== s.key"
        [disabled]="loading"
        [attr.title]="s.hint"
        (click)="setStack(s.key)">
        {{ s.label }}
      </button>
    </div>

    <button class="dark-btn dark-btn-sm" (click)="reload()" [disabled]="loading">
      <i class="fa-solid fa-rotate-right mr-1" [class.fa-spin]="loading"></i>Reload
    </button>

    <app-grid-copy-menu [gridApi]="grid?.api"></app-grid-copy-menu>
    <app-copy-source-button
      source="LSEG:INSTRUMENT_DETAILS"
      label="Copy Source"
      tooltip="Redis hash key — same on ws + srvr2 (stack toggle picks the box)">
    </app-copy-source-button>

    <span class="text-xs text-gray-500 dark:text-gray-400 ml-2">
      <strong>{{ rows.length }}</strong> symbol<span *ngIf="rows.length !== 1">s</span>
      · <strong>{{ columnDefs.length }}</strong> field<span *ngIf="columnDefs.length !== 1">s</span>
      in <code class="text-app-teal-100">LSEG:INSTRUMENT_DETAILS</code>
      <span class="ml-1">on <code class="text-app-teal-100">{{ stack }}</code> stack</span>
      <span *ngIf="loadedAt" class="ml-2">
        · loaded {{ loadedAt | date:'MMM d, y, h:mm:ss a' }}
      </span>
    </span>
  </div>

  <p class="text-xs text-gray-500 dark:text-gray-400">
    Read-only view of the fleet-shared instrument-details cache. Key + field
    shape are frozen through the LSEG→Massive cutover — consumers
    (Trinity, Block Hunter, theo-trade, per-customer scanners) read the
    same hash. Sort/filter freely; use the checkbox column to select rows,
    right-click for standard AG-Grid copy/export.
  </p>

  <ag-grid-angular
    class="w-full flex-1 min-h-[520px]"
    [rowData]="rows"
    [gridOptions]="grid.options"
    [statusBar]="grid.statusBar"
    [columnDefs]="columnDefs"
    [theme]="theme">
  </ag-grid-angular>
</div>
